import type { WorkshopsCardProps } from "../_model";
import { Show, splitProps } from "solid-js";

export function WorkshopCard(props: WorkshopsCardProps) {
  const [local, others] = splitProps(props, [
    "link",
    "image",
    "title",
    "category",
    "description",
    "id",
    "instructor",
    "start",
    "end",
    "status",
  ]);
  const dates = (() => {
    const start = new Date(local.start);
    const end = new Date(local.end);
    return {
      start: {
        monthName: start.toLocaleString("default", { month: "short" }).toUpperCase(),
        time: start.toLocaleString("default", { timeStyle: "short" }),
      },
      end: {
        monthName: end.toLocaleString("default", { month: "short" }).toUpperCase(),
        time: end.toLocaleString("default", { timeStyle: "short" }),
      },
    };
  })();
  return (
    <a
      {...others}
      href={local.link}
      target="_blank"
      class={
        "no-underline w-full min-h-400px flex flex-col relative rounded-xl bg-bg !overflow-hidden border-1 border-bg-alt border-solid" +
        " " +
        "<sm:(min-h-430px)" +
        " " +
        (others.class == undefined ? "" : others.class)
      }
    >
      <div class="flex w-full h-50%">
        <img class="w-full h-full object-stretch" src={local.image ?? "/images/placeholders/cover.png"} alt="alt" />
      </div>
      <div class="flex flex-col w-full h-full px-2 py-2 gap-1.5">
        <div class="flex flex-row text-0.4rem gap-2 children:(py-1.5 px-2 rounded-xl items-center text-center bg-brand-alt text-brand) ">
          <span>{local.category ?? "No category"}</span>
          <span>{local.status ?? "No status"}</span>
        </div>
        <p class="w-full min-h-30px font-bold overflow-hidden whitespace-nowrap truncate <sm:(min-h-40px)">
          {local.title ?? "No Title"}
        </p>
        <p class="flex flex-col w-full text-0.5rem gap-1">
          <span class="before:(content-['By:_'] text-text-alt) w-full overflow-hidden truncate">
            {local.instructor}
          </span>
          <span class="w-full text-start text-brand">{`${dates.start.monthName} ${dates.start.time} - ${dates.end.monthName} ${dates.end.time}`}</span>
        </p>

        <p class="h-full text-16px !overflow-y-auto overflow-x-hidden scrollbar">
          {local.description ?? "No description"}
        </p>
      </div>
    </a>
  );
}
